import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { FaUsers, FaCalendarCheck } from "react-icons/fa";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const formatoFecha = (fecha) =>
  fecha
    ? new Date(fecha).toLocaleDateString("es-MX", { day: "2-digit", month: "short", timeZone: "UTC" })
    : "";

export default function EstadisticasClubResumen() {
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await fetch("/api/asistencia-club/resumen", {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Error obteniendo resumen de club");
        setResumen(await res.json());
      } catch (err) {
        console.error("Error cargando resumen de club:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, []);

  if (loading) {
    return <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 h-72 animate-pulse" />;
  }

  if (error) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
        <p className="text-sm text-slate-400">No se pudo cargar la asistencia de club.</p>
      </div>
    );
  }

  const sinDatos = !resumen || resumen.tendencia.length === 0;
  const porcentaje = resumen?.totalUltima
    ? Math.round((resumen.presentesUltima / resumen.totalUltima) * 100)
    : 0;

  const data = {
    labels: (resumen?.tendencia || []).map((t) => formatoFecha(t.fecha)),
    datasets: [
      {
        label: "Asistencia",
        data: (resumen?.tendencia || []).map((t) =>
          t.total ? Math.round((t.presentes / t.total) * 100) : 0
        ),
        backgroundColor: "#4f46e5",
        borderRadius: 4,
        maxBarThickness: 28,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: (ctx) => `${ctx.parsed.y}% de asistencia` } },
    },
    scales: {
      x: { grid: { display: false }, ticks: { color: "#94a3b8" } },
      y: { grid: { color: "#f1f5f9" }, ticks: { color: "#94a3b8", callback: (v) => `${v}%` }, max: 100 },
    },
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
          <FaUsers />
        </span>
        <h2 className="text-base font-semibold text-slate-800">Asistencia a Club</h2>
      </div>

      <div className="grid grid-cols-3 gap-3 mb-5">
        <div className="bg-slate-50 rounded-lg p-3">
          <p className="text-xs text-slate-500 mb-1">Clubs activos</p>
          <p className="text-base font-bold text-slate-800">{resumen?.totalClubs ?? 0}</p>
        </div>
        <div className="bg-slate-50 rounded-lg p-3">
          <p className="text-xs text-slate-500 flex items-center gap-1 mb-1">
            <FaCalendarCheck className="text-[10px]" /> Última sesión
          </p>
          <p className="text-base font-bold text-slate-800">{formatoFecha(resumen?.ultimaFecha) || "—"}</p>
        </div>
        <div className="bg-slate-50 rounded-lg p-3">
          <p className="text-xs text-slate-500 mb-1">Asistencia</p>
          <p className="text-base font-bold text-slate-800">{sinDatos ? "—" : `${porcentaje}%`}</p>
        </div>
      </div>

      {sinDatos ? (
        <p className="text-sm text-slate-400 text-center py-10">Aún no hay asistencia registrada.</p>
      ) : (
        <div className="h-40">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
}
